import { combineReducers } from 'redux';

import authorCommentsReducer from './authorCommentsReducer';
import injuredBannedReducer from './injuredBannedReducer';
import smartAnalysisReducer from './smartAnalysisReducer';
import matchCardStandingsReducer from './matchCardStandingsReducer';
import matchCardStatisticsReducer from './matchCardStatisticsReducer';
import liveStatisticsReducer from './liveStatisticsReducer';
import fixtureReducer from './fixtureReducer';
import matchCardDetailsReducer from './matchCardDetailsReducer';
import matchCardOddsReducer from './matchCardOddsReducer';
import matchCardLeagueEventsReducer from './matchCardLeagueEventsReducer';
import matchCardStatisticMarketsReducer from './matchCardStatisticMarketsReducer';
import matchCardEventReducer from './matchCardEventReducer';
import matchCardTribunReducer from './matchCardTribunReducer';
import matchCardPopularMarketIdsReducer from './matchCardPopularMarketIdsReducer';
import matchCardPersonalMarketIdsReducer from './matchCardPersonalMarketIdsReducer';

import matchCardImportantMomentsReducer from './matchCardImportantMomentsReducer';
import matchCardMultipleLmtReducer from './matchCardMultipleLmtReducer';
import playerAnalysisReducer from './playerAnalysisReducer';
import matchCardHotBetsReducer from './matchCardHotBetsReducer';
import matchCardHeaderReducer from './matchCardHeaderReducer';
import bahistaReducer from './bahistaReducer';

export default combineReducers({
  header: matchCardHeaderReducer,
  event: matchCardEventReducer,
  authorComments: authorCommentsReducer,
  injuredBanned: injuredBannedReducer,
  smartAnalysis: smartAnalysisReducer,
  standings: matchCardStandingsReducer,
  matchCardStatistics: matchCardStatisticsReducer,
  liveStatistics: liveStatisticsReducer,
  fixtures: fixtureReducer,
  details: matchCardDetailsReducer,
  importantMoments: matchCardImportantMomentsReducer,
  odds: matchCardOddsReducer,
  leagueEvents: matchCardLeagueEventsReducer,
  statisticMarkets: matchCardStatisticMarketsReducer,
  tribun: matchCardTribunReducer,
  matchCardPopularMarketIds: matchCardPopularMarketIdsReducer,
  matchCardPersonalMarketIds: matchCardPersonalMarketIdsReducer,
  multipleLmt: matchCardMultipleLmtReducer,
  playerAnalysis: playerAnalysisReducer,
  hotBets: matchCardHotBetsReducer,
  bahista: bahistaReducer,
});
